<template>

    <form ref="certificacoespoliticapreco-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-5">
                <label for="politicaComercialNome">Nome</label>
                <input type="text" class="form-control" name="politicaComercialNome" placeholder="Nome da Politica Comercial" maxlength="50" v-model="model.nome" />
            </div>
            <div class="form-group col-md-1">
                <label>Ativa?</label>
                <div class="form-group">
                    <label class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" name="politicaComercialAtivo" value="undefined" class="custom-control-input" v-model="model.ativo">
                        <span class="custom-control-indicator"></span>
                    </label>

                </div>

            </div>
            <div class="table-responsive standard-table header-cinza">
                <table id="teste">
                    <thead>
                        <tr>
                            <th>ID<i></i></th>
                            <th>EXAME</th>
                            <th>VALOR PARA ALUNOS</th>
                            <th>VALOR PARA COLABORADORES</th>
                            <th>VALOR PARA EXTERNOS</th>
                            <th>VALOR PARA TROCA DE EXAMES</th>
                            <th>CONDIÇÃO APLICADA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.items" class="animated fadeIn">
                            <td>{{ item.interesseId}}</td>
                            <td>{{ item.interesse.nome}}</td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorAlunos" id="valorAlunos" v-model="item.valorAlunos">

                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorColaboradores" id="valorColaboradores" v-model="item.valorColaboradores" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorExternos" id="valorExternos" v-model="item.valorExternos" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorTrocaExames" id="valorTrocaExames" v-model="item.valorTrocaExames" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <label>Ativa?</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" name="anularAproveitamento" value="undefined" class="custom-control-input" v-model="item.anularAproveitamento">
                                            <span class="custom-control-indicator"></span>
                                        </label>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="openEdit(model)">
            <span>Salvar</span>
        </button>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" title="Confirmação">
            <p>Foram encontrados campos em branco. Deseja preenche-los com o valor "0,00"?</p>
            <div slot="modal-footer">
                <button type="button" class="btn btn-default" @click="cancelar()">
                    <span>Cancelar</span>
                </button>
                <button class="btn btn-sm btn-danger" @click="executeEdit(model)">
                    Confirmar
                </button>
            </div>
        </b-modal>
    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "certificacoespoliticapreco-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false,
            },
            model: {
                collectionCertificacoesPoliticaPrecoInteresse: [],
            },
            dialogEdit: false,

            filter: {
                pageSize: 50,
                pageIndex: 1,
                isPagination: true,
            },
            result: {
                total: 0,
                items: []
            },
            form: "certificacoespoliticapreco-form-edit",

            resources: {
                filter: 'interesse',
                edit: 'certificacoespoliticapreco',
                filterCertificacoesPoliticaPrecoInteresse: 'certificacoespoliticaprecointeresse',
            },

        }),

        methods: {

            cancelar: function () {
                this.dialogEdit = false;
            },

            openEdit: function (model) {
                this.model.collectionCertificacoesPoliticaPrecoInteresse = this.result.items;
                for (var i = 0; i < this.model.collectionCertificacoesPoliticaPrecoInteresse.length; i++) {
                    if (this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorAlunos == "0,00" || this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorColaboradores == "0,00" || this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorExternos == "0,00") {
                        this.dialogEdit = true;
                        break;
                    }
                }
                if (this.dialogEdit == false)
                    this.executeEdit(model);
            },

            executeEdit: function (model) {
                this.model.collectionCertificacoesPoliticaPrecoInteresse = this.result.items
                new Api('certificacoespoliticapreco/atualizar').put(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult("Edição realizada com sucesso");
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },
            onBack: function () {
                this.$emit('on-back')
            }
        },


        mounted() {
            new Api(this.resources.edit).get({ certificacoesPoliticaPrecoId: this.id, pageSize: 50 }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
            new Api(this.resources.filterCertificacoesPoliticaPrecoInteresse).get({ certificacoesPoliticaPrecoId: this.id, pageSize: 50 }).then(data => {
                if (data.dataList.length > 0) {
                    for (var i = 0; i < data.dataList.length; i++) {
                        data.dataList[i].valorAlunos = data.dataList[i].valorAlunos.toFixed(2)
                        data.dataList[i].valorColaboradores = data.dataList[i].valorColaboradores.toFixed(2)
                        data.dataList[i].valorExternos = data.dataList[i].valorExternos.toFixed(2)
                        data.dataList[i].valorTrocaExames = data.dataList[i].valorTrocaExames.toFixed(2)
                    }
                    this.result.items = data.dataList;
                } else {
                    new Api(this.resources.filter).get({ certificacoesPoliticaPrecoId: this.id, pageSize: 50 }).then(data => {
                        if (data.dataList.length > 0) {
                            this.result.items = data.dataList;
                        }
                    })
                }
            })
        }
    };
</script>